import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { SignatureType } from '@/features/privateCompanyLeadsFunnel/types/privateCompanyLead'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateContractEnvelopeSignatureTypeProps {
  id?: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useUpdateContractEnvelopeSignatureType = ({
  id,
  onSuccess,
  onError,
}: UseUpdateContractEnvelopeSignatureTypeProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateContractEnvelopeSignatureType'],
    mutationFn: async (signatureType: SignatureType) => {
      const private_company_lead = {
        contract_attributes: {
          signature_type: signatureType,
        },
      }

      await privateAxios.put(`/funnel/private_company_leads/${id}`, {
        private_company_lead,
      })
    },
    onSuccess,
    onError,
  })
}
